import Vue from "vue"

Vue.filter("enum", (value: string) => {
    if (!value) return ""
    return value.replace("_", " ")
})
